<template>
  <section class="margin-both-xl container">
    <WpImage 
     :image="data.image"
      size="large"
      cover
      background
      caption
    />
  </section>
</template>

<script>
import WpImage from '@/components/elements/WpImage'

export default {
  name: 'section-image',
  props: ['data'],
  components:{
      WpImage,
    },
}
</script>